/**
 * Download an authenticated file (PDF payout statement, admin CSV export) as a
 * browser file-save. Sends the session cookie (cookie-auth mode) and, when a
 * token is provided (impersonation / token-auth mode), an Authorization header —
 * mirroring baseQuery's auth behavior for regular requests.
 */
const API_BASE_URL =
  process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.startsWith('http')
    ? process.env.REACT_APP_API_URL
    : 'http://localhost:4000/api/v1';

export async function downloadAuthedFile(
  path: string,
  filename: string,
  token?: string | null
): Promise<void> {
  const headers: Record<string, string> = {};
  const isImpersonating =
    typeof window !== 'undefined' && localStorage.getItem('isImpersonating') === 'true';
  if (token && (isImpersonating || process.env.REACT_APP_USE_COOKIE_AUTH !== 'true')) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
  if (!response.ok) {
    throw new Error(`Download failed (${response.status})`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
}
